import { type MousePosT } from '../../../providers/stage-provider';
import { type CuboidAnnotationT } from '../../../types';
import { type CuboidDataT } from '../../../types/annotations.type';
import { VERTEX_TYPE } from '../shape/vertex';
import { VERTEX_RADIUS } from '../shape/vertex/constants';
export const NUMBER_OF_PRIMARY_VERTICES = 8;
export const CUBOID_FACE = Object.freeze({
  INITIAL: 'INITIAL',
  FINAL: 'FINAL'
});
export type CuboidFaceT = (typeof CUBOID_FACE)[keyof typeof CUBOID_FACE];
const CUBOID_VERTEX_MAP = {
  [VERTEX_TYPE.INITIAL_TOP_LEFT]: 0,
  [VERTEX_TYPE.INITIAL_TOP_RIGHT]: 1,
  [VERTEX_TYPE.INITIAL_BOTTOM_RIGHT]: 2,
  [VERTEX_TYPE.INITIAL_BOTTOM_LEFT]: 3,
  [VERTEX_TYPE.FINAL_TOP_LEFT]: 4,
  [VERTEX_TYPE.FINAL_TOP_RIGHT]: 5,
  [VERTEX_TYPE.FINAL_BOTTOM_RIGHT]: 6,
  [VERTEX_TYPE.FINAL_BOTTOM_LEFT]: 7,
  [VERTEX_TYPE.INITIAL]: 8,
  [VERTEX_TYPE.FINAL]: 9,
  [VERTEX_TYPE.LEFT_SIDE_TOP]: 10,
  [VERTEX_TYPE.LEFT_SIDE_BOTTOM]: 11,
  [VERTEX_TYPE.RIGHT_SIDE_TOP]: 12,
  [VERTEX_TYPE.RIGHT_SIDE_BOTTOM]: 13
};
export const getInitialCuboidPoints = (mousePos: [number, number]): CuboidDataT => {
  return {
    // @ts-expect-error todo(ts-migration) TS2322 Type 'any[]' is not assignable to type '[[number, number], [number, number], [number, number], [number, number], [number, number], [number, number], [number, number], [number, number]]'.
    points: new Array(8).fill(mousePos)
  };
};
export const getCuboidVertices = (cuboid: CuboidAnnotationT) => {
  const {
    points
  } = cuboid.data;
  const vertices = [{
    point: points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT],
    type: VERTEX_TYPE.INITIAL_TOP_LEFT
  }, {
    point: points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT],
    type: VERTEX_TYPE.INITIAL_TOP_RIGHT
  }, {
    point: points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT],
    type: VERTEX_TYPE.INITIAL_BOTTOM_RIGHT
  }, {
    point: points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT],
    type: VERTEX_TYPE.INITIAL_BOTTOM_LEFT
  }, {
    point: points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT],
    type: VERTEX_TYPE.FINAL_TOP_LEFT
  }, {
    point: points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT],
    type: VERTEX_TYPE.FINAL_TOP_RIGHT
  }, {
    point: points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT],
    type: VERTEX_TYPE.FINAL_BOTTOM_RIGHT
  }, {
    point: points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT],
    type: VERTEX_TYPE.FINAL_BOTTOM_LEFT
  }, {
    point: [
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][0] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][0]) / 2,
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][1] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][1]) / 2],
    type: VERTEX_TYPE.INITIAL
  }, {
    point: [
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][0] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][0]) / 2,
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][1] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][1]) / 2],
    type: VERTEX_TYPE.FINAL
  }, {
    point: [
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][0] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][0]) / 2,
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][1] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][1]) / 2],
    type: VERTEX_TYPE.LEFT_SIDE_TOP
  }, {
    point: [
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][0] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][0]) / 2,
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][1] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][1]) / 2],
    type: VERTEX_TYPE.LEFT_SIDE_BOTTOM
  }, {
    point: [
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][0] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][0]) / 2,
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][1] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][1]) / 2],
    type: VERTEX_TYPE.RIGHT_SIDE_TOP
  }, {
    point: [
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][0] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][0]) / 2,
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][1] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][1]) / 2],
    type: VERTEX_TYPE.RIGHT_SIDE_BOTTOM
  }];
  return vertices;
};
export const getCuboidSideFaces = (cuboid: CuboidAnnotationT) => {
  const {
    points
  } = cuboid.data;
  return {
    left: [points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT], points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT], points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT], points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT]],
    right: [points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT], points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT], points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT], points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT]],
    top: [points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT], points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT], points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT], points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT]],
    bottom: [points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT], points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT], points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT], points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT]]
  };
};
export const convertPointsForRender = (points: [number, number][]) => points.map(([x, y]) => `${x},${y}`).join(' ');
export const getCuboidOnDrawing = (face: CuboidFaceT, startPos: MousePosT, newPos: MousePosT, cuboid: CuboidAnnotationT, stageWidth: number, stageHeight: number): CuboidAnnotationT => {
  const [x0, y0] = startPos;
  const [x1, y1] = newPos;
  const deltaX = x1 - x0;
  const deltaY = y1 - y0;
  let points = [...cuboid.data.points];
  switch (face) {
    case CUBOID_FACE.INITIAL:
      {
        let x = Math.min(x0, x1);
        let y = Math.min(y0, y1);
        let width = Math.abs(x1 - x0);
        let height = Math.abs(y1 - y0);

        // Ensure all calculated points are within bounds
        if (stageWidth !== undefined && stageHeight !== undefined) {
          x = Math.max(0, x);
          y = Math.max(0, y);
          // Adjust width and height if they would exceed stage bounds
          if (x + width > stageWidth) {
            width = stageWidth - x;
          }
          if (y + height > stageHeight) {
            height = stageHeight - y;
          }
        }
        const initialRect = [[x, y], [x + width, y], [x + width, y + height], [x, y + height]];
        // @ts-expect-error todo(ts-migration) TS2322 Type 'number[][]' is not assignable to type '[number, number][]'.
        points = [...initialRect, ...initialRect];
        break;
      }
    case CUBOID_FACE.FINAL:
      {
        // final rect points are calc by adding delta to IN rect points
        // First calculate all points with the delta
        const finalPoints: [number, number][] = [];
        for (let i = NUMBER_OF_PRIMARY_VERTICES / 2; i <= NUMBER_OF_PRIMARY_VERTICES - 1; i++) {
          const newX =
          // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
          points[i - NUMBER_OF_PRIMARY_VERTICES / 2][0] + deltaX;
          const newY =
          // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
          points[i - NUMBER_OF_PRIMARY_VERTICES / 2][1] + deltaY;
          finalPoints.push([newX, newY]);
        }

        // Constrain the final face as a unit if stage bounds provided
        if (stageWidth !== undefined && stageHeight !== undefined) {
          // Find bounding box of final face points
          let minX = Infinity;
          let minY = Infinity;
          let maxX = -Infinity;
          let maxY = -Infinity;
          for (const [x, y] of finalPoints) {
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }

          // Calculate offset needed to bring final face back into bounds
          let offsetX = 0;
          let offsetY = 0;
          if (minX < 0) {
            offsetX = -minX;
          } else if (maxX > stageWidth) {
            offsetX = stageWidth - maxX;
          }
          if (minY < 0) {
            offsetY = -minY;
          } else if (maxY > stageHeight) {
            offsetY = stageHeight - maxY;
          }

          // Apply offset to all final face points if needed
          if (offsetX !== 0 || offsetY !== 0) {
            for (let i = 0; i < finalPoints.length; i++) {
              const point = finalPoints[i];
              if (point) {
                finalPoints[i] = [point[0] + offsetX, point[1] + offsetY];
              }
            }
          }
        }

        // Assign the final points back to the points array
        for (let i = 0; i < finalPoints.length; i++) {
          const point = finalPoints[i];
          if (point) {
            points[NUMBER_OF_PRIMARY_VERTICES / 2 + i] = point;
          }
        }
        break;
      }
    default:
      break;
  }
  return {
    ...cuboid,
    data: {
      // @ts-expect-error todo(ts-migration) TS2322 Type '[number, number][]' is not assignable to type '[[number, number], [number, number], [number, number], [number, number], [number, number], [number, number], [number, number], [number, number]]'....
      points
    }
  };
};
export const getTranslatedCuboid = (deltaX: number, deltaY: number, cuboid: CuboidAnnotationT, stageWidth: number, stageHeight: number): CuboidAnnotationT => {
  const points = [...cuboid.data.points];
  points.forEach((point, index) => {
    points[index] = [point[0] + deltaX, point[1] + deltaY];
  });

  // Constrain all points to stage bounds if dimensions provided
  if (stageWidth !== undefined && stageHeight !== undefined) {
    // Find the bounding box of all points
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (const [x, y] of points) {
      minX = Math.min(minX, x);
      minY = Math.min(minY, y);
      maxX = Math.max(maxX, x);
      maxY = Math.max(maxY, y);
    }

    // Calculate offset needed to bring points back into bounds
    let offsetX = 0;
    let offsetY = 0;
    if (minX < 0) {
      offsetX = -minX;
    } else if (maxX > stageWidth) {
      offsetX = stageWidth - maxX;
    }
    if (minY < 0) {
      offsetY = -minY;
    } else if (maxY > stageHeight) {
      offsetY = stageHeight - maxY;
    }

    // Apply offset to all points if needed
    if (offsetX !== 0 || offsetY !== 0) {
      points.forEach((point, index) => {
        points[index] = [point[0] + offsetX, point[1] + offsetY];
      });
    }
  }
  return {
    ...cuboid,
    data: {
      // @ts-expect-error todo(ts-migration) TS2322 Type '[number, number][]' is not assignable to type '[[number, number], [number, number], [number, number], [number, number], [number, number], [number, number], [number, number], [number, number]]'....
      points
    }
  };
};
export const getTransformedCuboidOnVertexMove = (cuboid: CuboidAnnotationT, selectedVertexIndex: number, startPos: MousePosT, newPos: MousePosT): CuboidAnnotationT => {
  const deltaX = newPos[0] - startPos[0];
  const deltaY = newPos[1] - startPos[1];
  const points = [...cuboid.data.points];

  // points.forEach((point, index) => {
  //   points[index] = index === selectedVertexIndex ? newPos : point;
  // });
  switch (selectedVertexIndex) {
    /**
     * We are making sure that vertex moving in a direction should not cross the other vertex
     * and there should be at least 2 * VERTEX_RADIUS between them so that there won't be
     * overlap in the vertices. So finding new position = initial_pos + delta and
     * comparing it with other vertex in that direction and taking min/max depending
     * on that direction.
     */
    case CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT:
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT] = [Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][0] - 2 * VERTEX_RADIUS), Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][1] - 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][0], Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][1] - 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT] = [Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][0] - 2 * VERTEX_RADIUS),
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][1]];
      break;
    case CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT:
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT] = [Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][0] + 2 * VERTEX_RADIUS), Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][1] - 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][0], Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][1] - 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT] = [Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][0] + 2 * VERTEX_RADIUS),
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][1]];
      break;
    case CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT:
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT] = [Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][0] + 2 * VERTEX_RADIUS), Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][1] + 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT] = [Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][0] + 2 * VERTEX_RADIUS),
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][1]];
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][0], Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][1] + 2 * VERTEX_RADIUS)];
      break;
    case CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT:
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT] = [Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][0] - 2 * VERTEX_RADIUS), Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][1] + 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT] = [Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][0] - 2 * VERTEX_RADIUS),
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][1]];
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][0], Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][1] + 2 * VERTEX_RADIUS)];
      break;
    case CUBOID_VERTEX_MAP.FINAL_TOP_LEFT:
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT] = [Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][0] - 2 * VERTEX_RADIUS), Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][1] - 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][0], Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][1] - 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT] = [Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][0] - 2 * VERTEX_RADIUS),
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][1]];
      break;
    case CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT:
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT] = [Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][0] + 2 * VERTEX_RADIUS), Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][1] - 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][0], Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][1] - 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT] = [Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][0] + 2 * VERTEX_RADIUS),
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][1]];
      break;
    case CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT:
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT] = [Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][0] + 2 * VERTEX_RADIUS), Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][1] + 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT] = [Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][0] + 2 * VERTEX_RADIUS),
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][1]];
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][0], Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][1] + 2 * VERTEX_RADIUS)];
      break;
    case CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT:
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT] = [Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][0] - 2 * VERTEX_RADIUS), Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][1] + 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT] = [Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][0] + deltaX,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][0] - 2 * VERTEX_RADIUS),
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][1]];
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][0], Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][1] + 2 * VERTEX_RADIUS)];
      break;
    case CUBOID_VERTEX_MAP.INITIAL:
      for (let i = 0; i <= NUMBER_OF_PRIMARY_VERTICES / 2 - 1; i++) {
        // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
        points[i] = [points[i][0] + deltaX, points[i][1] + deltaY];
      }
      break;
    case CUBOID_VERTEX_MAP.FINAL:
      for (let i = NUMBER_OF_PRIMARY_VERTICES / 2; i <= NUMBER_OF_PRIMARY_VERTICES - 1; i++) {
        // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
        points[i] = [points[i][0] + deltaX, points[i][1] + deltaY];
      }
      break;
    case CUBOID_VERTEX_MAP.LEFT_SIDE_TOP:
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][0], Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][1] - 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][0], Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][1] - 2 * VERTEX_RADIUS)];
      break;
    case CUBOID_VERTEX_MAP.LEFT_SIDE_BOTTOM:
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][0], Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_LEFT][1] + 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][0], Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_LEFT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_LEFT][1] + 2 * VERTEX_RADIUS)];
      break;
    case CUBOID_VERTEX_MAP.RIGHT_SIDE_TOP:
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][0], Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][1] - 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][0], Math.min(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][1] - 2 * VERTEX_RADIUS)];
      break;
    case CUBOID_VERTEX_MAP.RIGHT_SIDE_BOTTOM:
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][0], Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_BOTTOM_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.INITIAL_TOP_RIGHT][1] + 2 * VERTEX_RADIUS)];
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT] = [
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][0], Math.max(
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_BOTTOM_RIGHT][1] + deltaY,
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      points[CUBOID_VERTEX_MAP.FINAL_TOP_RIGHT][1] + 2 * VERTEX_RADIUS)];
      break;
    default:
      break;
  }
  return {
    ...cuboid,
    data: {
      // @ts-expect-error todo(ts-migration) TS2322 Type '[number, number][]' is not assignable to type '[[number, number], [number, number], [number, number], [number, number], [number, number], [number, number], [number, number], [number, number]]'....
      points
    }
  };
};
export const interpolateCuboid = (initialCuboid: CuboidDataT, finalCuboid: CuboidDataT, interpolationFactor: number): CuboidDataT => {
  const points = initialCuboid.points.map((point, index) => {
    return [
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    initialCuboid.points[index][0] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (finalCuboid.points[index][0] - point[0]) * interpolationFactor,
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    initialCuboid.points[index][1] +
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    (finalCuboid.points[index][1] - point[1]) * interpolationFactor];
  });
  return {
    // @ts-expect-error todo(ts-migration) TS2322 Type 'number[][]' is not assignable to type '[[number, number], [number, number], [number, number], [number, number], [number, number], [number, number], [number, number], [number, number]]'.
    points
  };
};